import { render, staticRenderFns } from "./newsreport.vue?vue&type=template&id=6c0bcfb5&scoped=true&"
import script from "./newsreport.vue?vue&type=script&lang=js&"
export * from "./newsreport.vue?vue&type=script&lang=js&"
import style0 from "./newsreport.vue?vue&type=style&index=0&id=6c0bcfb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0bcfb5",
  null
  
)

export default component.exports